export function removeQueriesFromUrl(url: string) {
  return url?.split("?")[0];
}
